<template>
  <div class='main'>
    <div class="statis_box_select">
      <div>
        <el-cascader
          style="margin:10px 0 0 20px"
          placeholder="请选择班级"
          v-model="TestEvaParams.classid"
          :options="classList"
          clearable
          :show-all-levels="false"
          @change="GetTestEvaData"
          :props="{ expandTrigger: 'hover',label:'orgname',value:'orgid',emitPath:false }"
        ></el-cascader>
        <el-cascader
          style="margin:10px 0 0 20px"
          placeholder="请选择实验"
          v-model="TestEvaParams.experimentid"
          :options="experList"
          clearable
          :show-all-levels="false"
          @change="GetTestEvaData"
          :props="{ expandTrigger: 'hover',label:'itemname',value:'itemid',emitPath:false }"
        ></el-cascader>
      </div>
    </div>
    <div class="bottom">
      <el-table
        :data="TestEvaTableData"
        stripe
        empty-text="请选择班级和实验"
        tooltip-effect
        style="width: 100%"
      >
        <el-table-column
          label="序号"
          width="80"
          type="index"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="username"
          label="学生姓名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="usercode"
          label="学号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="videoscore"
          label="视频得分"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="operatescore"
          label="操作得分"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="checkscore"
          label="考核得分"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="allscore"
          label="总分"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="isokname"
          label="是否合格"
          align="center"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              @click="TestEvaClick(scope.row)"
              type="text"
              size="small"
            >详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 测评统计详情 -->
      <el-dialog
        title="测评统计详情"
        :visible.sync="evaluationDialog"
        width="31%"
        @open="evaluationOpen()"
      >
        <div
          id="evaluation"
          style="width:100%;height:500px"
        >
        </div>
      </el-dialog>

      <div class="pagination">
        <el-pagination
          :hide-on-single-page="true"
          :total="TestEvaParams.TestEvaTotal"
          :page-size="TestEvaParams.pagesize"
          :current-page.sync='TestEvaParams.pageindex'
          @current-change="GetTestEvaData"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'
import echarts from 'echarts'

export default {
  data () {
    return {
      classList: [],
      experList: [],
      TestEvaParams: {
        classid: '',
        experimentid: '',
        pageindex: 1,
        pagesize: 11,
        TestEvaTotal: 0,
      },
      TestEvaTableData: [],
      evaluationDialog: false,
      indicator: [],
      evaluationOption: {
        title: {
          // text: '基础雷达图'
        },
        tooltip: {},
        legend: {
          // data: ['预算分配（Allocated Budget）']
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: '#fff',
              backgroundColor: '#999',
              borderRadius: 3,
              padding: [3, 5]
            },
          },
          indicator: [],
        },
        series: [{
          name: '测评结果分析',
          type: 'radar',
          // areaStyle: {normal: {}},
          data: [
            {
              value: [4300, 10000, 28000, 35000, 50000, 19000],
              // name: '预算分配（Allocated Budget）'
              itemStyle: {
                normal: {
                  color: '#A4D3EE'  //显示颜色与填充颜色对应
                }
              },
              areaStyle: {
                normal: {
                  color: '#A4D3EE'    //填充的颜色
                }
              },
            }
          ]
        }]
      },
    }
  },
  created () {
    this.GetOrgDataTree()
    this.GetExperTree()
    this.GetTestEvaData()
  },
  methods: {
    //获取系室专业班级树形图
    async GetOrgDataTree () {
      const res = await Api.organization.GetOrgDataTree()
      this.classList = res.rows
    },
    //获取实验树形结构
    async GetExperTree () {
      const res = await Api.sum.GetExperTree()
      this.experList = res.rows
    },
    //统计测评数据
    async GetTestEvaData () {
      console.log(this.TestEvaParams);
      const res = await Api.sum.GetTestEvaData(this.TestEvaParams)
      this.TestEvaTableData = res.rows
      this.TestEvaParams.TestEvaTotal = res.total
    },
    //统计测评详情
    async TestEvaClick (e) {
      const res = await Api.sum.GetTestEvaDetail(e.userid)
      if (res.success != true) return this.$message.info(res.msg)
      this.evaluationOption.series[0].data[0].value = res.rows.valuelist
      this.evaluationOption.radar.indicator = res.rows.namelist
      this.evaluationDialog = true
    },
    renderChart (option, dom) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById(dom))
      myChart.setOption(option)
    },
    evaluationOpen () {
      this.$nextTick(() => {
        this.renderChart(this.evaluationOption, 'evaluation')
      })
    }
  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background: #fff;
  .bottom {
    padding-top: 20px;
  }
  /deep/.el-dialog {
    border-radius: 7px;
    .el-dialog__header {
      margin: 0 15px;
      border-bottom: 1px solid #ccc;
    }
  }
}
</style>